exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-case-studies-hygraph-case-study-slug-tsx": () => import("./../../../src/pages/case-studies/{HygraphCaseStudy.slug}.tsx" /* webpackChunkName: "component---src-pages-case-studies-hygraph-case-study-slug-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-next-tsx": () => import("./../../../src/pages/next.tsx" /* webpackChunkName: "component---src-pages-next-tsx" */)
}

